import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_item_review_hdr_RowClass, bl_fi_mst_attribute_hdr_RowClass, bl_fi_mst_item_attribute_set_link_RowClass,
  bl_fi_mst_item_hdr_RowClass, bl_fi_mst_item_attribute_child_link_RowClass,
  bl_fi_mst_pricing_scheme_link_RowClass,
  bl_fi_mst_item_ext_RowClass
} from '../../../dbschema';
import {PowerSearchEcomSyncItemContainerModel} from './power-search-ecom-sync-item-container.model';

export class PowerSearchContainerModel extends BaseContainerModel {
  bl_fi_mst_item_hdr: bl_fi_mst_item_hdr_RowClass = new bl_fi_mst_item_hdr_RowClass();
  bl_fi_mst_item_exts: bl_fi_mst_item_ext_RowClass[] = [];
  powerSearchEcomSyncItemContainer: PowerSearchEcomSyncItemContainerModel;
  bl_fi_mst_pricing_scheme_link: bl_fi_mst_pricing_scheme_link_RowClass = new bl_fi_mst_pricing_scheme_link_RowClass();
  bl_fi_mst_pricing_scheme_link_2: bl_fi_mst_pricing_scheme_link_RowClass[] = [];
  bl_fi_item_review_hdrs: bl_fi_item_review_hdr_RowClass[] = [];
  bl_fi_mst_item_attribute_set_links: bl_fi_mst_item_attribute_set_link_RowClass[] = [];
  bl_fi_mst_attribute_hdrs: bl_fi_mst_attribute_hdr_RowClass[] = [];
  bl_fi_mst_item_attribute_child_links: bl_fi_mst_item_attribute_child_link_RowClass[] = [];
}
